import React, { Component } from "react";
import { string, shape, bool, func, objectOf, arrayOf, node } from "prop-types";

import * as i18nUtils from "util/i18n";
import Password from "pages/_components/fields/credentials/Password";
import Button from "pages/_components/Button";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { actions as tokenActions, selectors as tokenSelectors } from "reducers/token";
import { selectors as sessionSelectors } from "reducers/session";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import isTokenActive from "util/token";

const styles = {
    hidden: {
        opacity: 0,
        position: "absolute",
        zIndex: "-9999",
    },
};

class Credential extends Component {
    static propTypes = {
        type: string,
        field: shape({}),
        copyEnabled: bool,
        dispatch: func.isRequired,
        tokenNumber: string,
        form: shape({
            errors: objectOf({}),
            touched: objectOf({}),
        }).isRequired,
        loggedUser: shape({
            previousLoginInfo: arrayOf(
                shape({
                    idUser: string,
                }),
            ),
        }).isRequired,
        inputProps: shape({}),
        withoutOtpTxt: node,
        otpTxt: node,
        onChange: func,
        isMobileNative: bool,
        submitForm: func,
        fetchingToken: bool,
        isTokenSeedAvailable: bool,
    };

    static defaultProps = {
        type: "password",
        field: {},
        copyEnabled: true,
        tokenNumber: null,
        inputProps: { autofocus: false },
        withoutOtpTxt: null,
        otpTxt: null,
        onChange: null,
        submitForm: null,
        isMobileNative: false,
        fetchingToken: false,
        isTokenSeedAvailable: false,
    };

    componentDidMount = () => {
        const { type, dispatch, loggedUser, form, field, isMobileNative } = this.props;

        const otpMobile = type === "otp" && isTokenActive() && loggedUser;

        if (otpMobile) {
            dispatch(tokenActions.tokenQueryCredential("Token", loggedUser?.userId, form, field));
        }
        if (isMobileNative) {
            dispatch(tokenActions.verifyTokenSeedExist());
        }
    };

    updateCode = () => {
        const { dispatch, loggedUser, form, field } = this.props;
        dispatch(tokenActions.tokenGeneratedValue(loggedUser?.userId, form, field));
        // repeat animation in 0.5 seconds
        return [true, 500];
    };

    generateBiometricsToken = () => {
        const { dispatch, submitForm, form, field, isTokenSeedAvailable } = this.props;
        if (isTokenSeedAvailable) {
            dispatch(tokenActions.generateBiometricsToken(submitForm, form, field));
        } else {
            dispatch(
                routerActions.replace({
                    pathname: "/recoveryPassword/step2/processDisclaimerBiometrics",
                    state: { transition: "transition-drill-out" },
                }),
            );
        }
    };

    render() {
        const { type, inputProps, withoutOtpTxt, otpTxt, onChange, fetchingToken, ...props } = this.props;

        if (type === "password") {
            return (
                <Password
                    autoFocus={inputProps.autofocus}
                    autoComplete="off"
                    copyEnabled
                    onChange={onChange}
                    {...props}
                />
            );
        }

        if (type === "otp") {
            const {
                field: { name },
                loggedUser,
            } = this.props;

            return (
                <React.Fragment>
                    <div>
                        {isTokenActive() && loggedUser ? (
                            <div>
                                {withoutOtpTxt}
                                <div className="hide">
                                    <CountdownCircleTimer
                                        isPlaying
                                        duration={40}
                                        trailColor={[["#18e2a7"]]}
                                        colors={[["#d9d9d9"]]}
                                        size={260}
                                        strokeLinecap="square"
                                        strokeWidth={9}
                                        onComplete={() => this.updateCode()}
                                    />
                                </div>
                            </div>
                        ) : (
                            <>
                                {otpTxt}
                                <div>
                                    {/*
                                    The objetive of this input is to avoid the differents
                                    behaviors of autocomplete="off" of browsers.
                                    */}
                                    <input
                                        name={name}
                                        style={styles.hidden}
                                        type="password"
                                        aria-hidden
                                        tabIndex="-1"
                                    />
                                    <Password
                                        autoComplete="new-password"
                                        inputmode="numeric"
                                        pattern="[0-9]{0,6}"
                                        copyEnabled
                                        {...props}
                                        warningMessage={i18nUtils.get("form.credential.otp.warning")}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </React.Fragment>
            );
        }

        if (type === "mobilePhone") {
            return <Password autoComplete="off" inputmode="numeric" copyEnabled onChange={onChange} {...props} />;
        }

        if (type === "otpMobile") {
            return (
                <Password
                    autoComplete="off"
                    inputmode="numeric"
                    pattern="[0-9]{0,6}"
                    copyEnabled
                    {...props}
                    warningMessage={i18nUtils.get("form.credential.otp.warning")}
                />
            );
        }

        if (type === "tokenPass") {
            const {
                field: { name },
            } = this.props;

            return (
                <React.Fragment>
                    <input name={name} style={styles.hidden} type="password" aria-hidden tabIndex="-1" />
                    <Password
                        autoComplete="off"
                        inputmode="numeric"
                        pattern="[0-9]{0,6}"
                        copyEnabled
                        {...props}
                        warningMessage={i18nUtils.get("settings.tokenPassword.password.warning")}
                        autofocus
                    />
                </React.Fragment>
            );
        }

        if (type === "biometrics") {
            return (
                <React.Fragment>
                    <Button
                        type="button"
                        bsStyle="primary"
                        label="biometrics.recovery.label"
                        image="images/fingerprint-outline.svg"
                        imageStyle="mr-2"
                        onClick={this.generateBiometricsToken}
                        loading={fetchingToken}
                    />
                </React.Fragment>
            );
        }

        return null;
    }
}
const mapStateToProps = (state) => ({
    tokenNumber: tokenSelectors.getTokenNumber(state),
    loggedUser: sessionSelectors.getUser(state),
    fetchingToken: tokenSelectors.getFetchingToken(state),
    isTokenSeedAvailable: tokenSelectors.getIsTokenSeedAvailable(state),
});

export default connect(mapStateToProps)(Credential);
